import React, { useRef } from 'react';
import './contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { AiFillPhone } from 'react-icons/ai';
import { BsWhatsapp } from 'react-icons/bs';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Input from './components/Input';
import Textarea from './components/Textarea';

const Contact = () => {
  const form = useRef();
  const notify = () => toast('Thank you for getting in touch! ');
  // console.log('ENV', process.env.NODE_ENV);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        process.env.REACT_APP_DEV_MODE_EMAILJSSENDFROM,
        process.env.REACT_APP_DEV_MODE_TEMP,
        form.current,
        '7S7SVKfhRD7NZnwCP',
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        },
      );
    notify();
    e.target.reset();
  };
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className='container contact__container'>
        <div className='contact__options'>
          <ToastContainer
            progressClassName='toastProgress'
            bodyClassName='toastBody'
          />
          <a
            href='mailto:rigers.allaraj7@gmail.com'
            className='contact__option'
            target='_blank'>
            <MdOutlineEmail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>rigers.allaraj7@gmail.com</h5>
            Send a message
          </a>
          <a
            href='https://api.whatsapp.com/send?phone+0684818539'
            className='contact__option'
            target='_blank'>
            <BsWhatsapp className='contact__option-icon' />
            <h4>WhatsApp</h4>
            <h5>+0684818539</h5>
            Send a message
          </a>
          <a href='tel:0684818539' className='contact__option' target='_blank'>
            <AiFillPhone className='contact__option-icon' />
            {/* <h4>Messenger</h4>
            <h5>gersi allaraj</h5>
            <a href='https:://m.me/gersi.allaraj' target='_blank'>
              Send a message
            </a> */}
            <h4>Phone number</h4>
            <h5>+0684818539</h5>
            Click to Call
          </a>
        </div>
        {/* END OF CONTACTION */}
        <form ref={form} onSubmit={sendEmail}>
            <Input
              type='text'
              name='name'
              pattern='[a-zA-z]+'
              title="Name should have this format 'Rigers'"
              placeholder="Your Full Name"
            />      
               
            <Input type='email' name='email' placeholder="Your Email" />
            <Textarea type='message' name='message' placeholder="Your Message" />
            <button type='submit' className='btn btn-primary btn-animation-contact'>
              Send Message
            </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
